import axios, { AxiosError } from 'axios';
import { useMutation, UseMutationOptions } from 'react-query';
import { auth } from '@olo-web/utils/google/firebase';

export const setAdmin = async (body: ISetAdminRequestBody): Promise<ISetAdminResponse> => {
  try {
    const idToken = await auth().currentUser.getIdToken();
    const { data } = await axios.post(`/api/users/set-admin`, body, {
      headers: { Authorization: `Bearer ${idToken}` },
    });
    return data;
  } catch (error) {
    console.error(error);
    throw new Error(error?.response?.data?.message || error?.response?.data?.error || error);
  }
};

export const useSetAdmin = (
  options?: UseMutationOptions<ISetAdminResponse, AxiosError, ISetAdminRequestBody>
) => {
  return useMutation(setAdmin, options);
};
